import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { Row, Button, Card } from 'react-bootstrap';
import SortableTableClassic from '../table/SortableTableClassic';
const Moment = require('moment');
const get = require('lodash/get');
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');
const StringUtil = require('../../../../app/shared/StringUtil');
const ServerRequest = require('../../actions/request');
import withSignInStoreState  from '../DataHOCs/WithSignInStoreState';
const AnalyticsStore = require('../../stores/AnalyticsStore');
const AnalyticsActions = require('../../actions/AnalyticsActions');
import ErrorBox from '../common/ErrorBox';
import StatTile from '../tiles/StatTile';
const ExportsUtil = require('../../util/ExportsUtil');

const propTypes = {
    className: PropTypes.string,
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    signInStoreState: PropTypes.shape({ userInfo: PropTypes.shape({ admin: PropTypes.bool }).isRequired }).isRequired,
};
const defaultProps = {
    className: "",
};

class ChannelShareReport extends React.Component {
    constructor(props) {
        super(props);
        this.pollTaskManager = new ServerRequest.PollTaskManager();
        this.state = {
            displayDate: null,
            pickerDate: Moment().subtract(1, 'M').date(1).toDate(),
            selectedProjectId: null,
            selectedActivityId: null,
            getChannelShareReportActionId: null,
            getChannelShareReportError: null,
            getChannelActivityShareReportActionId: null,
            getChannelActivityShareReportError: null,
            getChannelProjectShareReportActionId: null,
            getChannelProjectShareReportError: null,
        };

        this.onPickerDateChange = this.onPickerDateChange.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
        this.onUpdateActivity = this.onUpdateActivity.bind(this);
        this.onUpdateProject = this.onUpdateProject.bind(this);
        this.getChannelShareReport = this.getChannelShareReport.bind(this);
        this.getChannelActivityShareMonthStats = this.getChannelActivityShareMonthStats.bind(this);
        this.getChannelProjectShareMonthStats = this.getChannelProjectShareMonthStats.bind(this);
        this.unsubscribes = [
            AnalyticsStore.listen(this.onAnalyticsStoreChange.bind(this))
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
        this.pollTaskManager.abandonTasks();
    }

    onAnalyticsStoreChange(newState) {
        let updatedState = {};
        if (newState.action.id === this.state.getChannelShareReportActionId) {
            updatedState.getChannelShareReportActionId = null;
            if (newState.action.error) {
                updatedState.getChannelShareReportError = newState.action.error;
            }
        }

        if (newState.action.id === this.state.getChannelActivityShareReportActionId) {
            updatedState.getChannelActivityShareReportActionId = null;
            if (newState.action.error) {
                updatedState.getChannelActivityShareReportError = newState.action.error;
            }
        }

        if (newState.action.id === this.state.getChannelProjectShareReportActionId) {
            updatedState.getChannelProjectShareReportActionId = null;
            if (newState.action.error) {
                updatedState.getChannelProjectShareReportError = newState.action.error;
            }
        }

        if (Object.keys(updatedState).length === 0) return;
        this.setState(updatedState);
    }

    onPickerDateChange(date) {
        this.setState({ pickerDate: date });
    }

    onUpdate() {
        let updatedState = { displayDate: this.state.pickerDate, selectedProjectId: null, selectedActivityId: null };
        let callback = null;
        const dateToFetch = Moment(this.state.pickerDate);
        const currentUTCDate = Moment.utc();
        const isCurrentUTCMonth = dateToFetch.month() === currentUTCDate.month() && dateToFetch.year() === currentUTCDate.year();
        const dataForMonth = this.getChannelShareReport(AnalyticsStore.getState(), this.props.channelId, dateToFetch.format('YYYY-MM'));
        if (!dataForMonth || isCurrentUTCMonth) { // only get data if it doesn't exist or if it's the current month
            const actionId = uuid.v4();
            updatedState.getChannelShareReportActionId = actionId;
            updatedState.getChannelShareReportError = null;
            callback = () => {
                AnalyticsActions.getChannelShareMonthOverview(actionId, {
                    channelId: this.props.channelId,
                    date: dateToFetch.format('YYYY-MM')
                }, this.pollTaskManager);
            };
        }
        
        this.setState(updatedState, () => {
            if (callback) callback();
        });
    }

    onUpdateActivity() {
        let updatedState =  {};
        let callback = null;
        const dateToFetch = Moment(this.state.pickerDate);
        const currentUTCDate = Moment.utc();
        const isCurrentUTCMonth = dateToFetch.month() === currentUTCDate.month() && dateToFetch.year() === currentUTCDate.year();
        const dataForMonth = this.getChannelActivityShareMonthStats(
                AnalyticsStore.getState(),
                this.props.channelId,
                this.state.selectedActivityId,
                dateToFetch.format('YYYY-MM')
            );
        if (!dataForMonth || isCurrentUTCMonth) { // only get data if it doesn't exist or if it's the current month
            const actionId = uuid.v4();
            updatedState.getChannelActivityShareReportActionId = actionId;
            updatedState.getChannelActivityShareReportError = null;
            callback = () => {
                AnalyticsActions.getChannelActivityShareMonthOverview(actionId, {
                    channelId: this.props.channelId,
                    activityId: this.state.selectedActivityId,
                    date: dateToFetch.format('YYYY-MM')
                }, this.pollTaskManager);
            };
        }
        
        this.setState(updatedState, () => {
            if (callback) callback();
        });
    }

    onUpdateProject() {
        let updatedState =  {};
        let callback = null;
        const dateToFetch = Moment(this.state.pickerDate);
        const currentUTCDate = Moment.utc();
        const isCurrentUTCMonth = dateToFetch.month() === currentUTCDate.month() && dateToFetch.year() === currentUTCDate.year();
        const dataForMonth = this.getChannelProjectShareMonthStats(
                AnalyticsStore.getState(),
                this.props.channelId,
                this.state.selectedProjectId,
                dateToFetch.format('YYYY-MM')
            );
        if (!dataForMonth || isCurrentUTCMonth) { // only get data if it doesn't exist or if it's the current month
            const actionId = uuid.v4();
            updatedState.getChannelProjectShareReportActionId = actionId;
            updatedState.getChannelProjectShareReportError = null;
            callback = () => {
                AnalyticsActions.getChannelProjectShareMonthOverview(actionId, {
                    channelId: this.props.channelId,
                    projectId: this.state.selectedProjectId,
                    date: dateToFetch.format('YYYY-MM')
                }, this.pollTaskManager);
            };
        }
        
        this.setState(updatedState, () => {
            if (callback) callback();
        });
    }

    getChannelShareReport(storeState, channelId, date) {
        return get(storeState, ['channelShareMonthStats', channelId, Moment(date).format('YYYY-MM')], null);
    }

    getChannelActivityShareMonthStats(storeState, channelId, activityId, date) {
        return get(storeState, ['channelActivityShareMonthStats', channelId, activityId, Moment(date).format('YYYY-MM')], null);
    }

    getChannelProjectShareMonthStats(storeState, channelId, projectId, date) {
        return get(storeState, ['channelProjectShareMonthStats', channelId, projectId, Moment(date).format('YYYY-MM')], null);
    }

    onExportAccessors(rows, fileNamePrefix) {
        const tableArr = [
            [
                Strings['en'].analytics.new_students.share.accessor_table.IP_ADDRESS,
                Strings['en'].analytics.new_students.share.accessor_table.FIRST_ACCESS_DATE,
                Strings['en'].analytics.new_students.share.accessor_table.TOTAL_ACCESSES
            ]
        ];

        rows.forEach((row) => {
            tableArr.push([
                row.ip_address,
                Moment(row.first_access_date).utc().format("YYYY-MM-DD HH:MM:ss z"),
                row.total_shares
            ]);
        });

        ExportsUtil.exportArrAsCsv(
            tableArr,
            `${fileNamePrefix}${Moment(this.state.displayDate).format('YYYY-MM')}`,
            Strings['en'].export.DOWNLOAD_CSV_FILE
        );
    }

    onExportProjects(rows, fileNamePrefix) {
        const tableArr = [
            [
                Strings['en'].analytics.new_students.share.proj_table.PROJECT_NAME,
                Strings['en'].analytics.new_students.share.proj_table.FIRST_ACCESS_DATE,
                Strings['en'].analytics.new_students.share.proj_table.UNIQUE_SHARES,
                Strings['en'].analytics.new_students.share.proj_table.TOTAL_SHARES,
            ]
        ];

        rows.forEach((row) => {
            tableArr.push([
                row.name,
                Moment(row.first_access_date).utc().format("YYYY-MM-DD HH:MM:ss z"),
                row.count,
                row.count_non_unique
            ]);
        });

        ExportsUtil.exportArrAsCsv(
            tableArr,
            `${fileNamePrefix}${Moment(this.state.displayDate).format('YYYY-MM')}`,
            Strings['en'].export.DOWNLOAD_CSV_FILE
        );
    }

    onExportActivities(rows, projectId, projectName, fileNamePrefix) {
        const tableArr = [
            [
                Strings['en'].analytics.new_students.share.act_table.ACTIVITY_TITLE,
                Strings['en'].analytics.new_students.share.act_table.FIRST_ACCESS_DATE,
                Strings['en'].analytics.new_students.share.act_table.UNIQUE_SHARES,
                Strings['en'].analytics.new_students.share.act_table.TOTAL_SHARES,
            ]
        ];

        rows.forEach((row) => {
            tableArr.push([
                row.title,
                Moment(row.first_access_date).utc().format("YYYY-MM-DD HH:MM:ss z"),
                row.count,
                row.count_non_unique
            ]);
        });

        // add project name at end of CSV
        if (!!projectName) {
            tableArr.push([ // newline
                "",
                "",
            ]);
            tableArr.push([
                `${Strings['en'].project.PROJECT}: ${projectName}`,
                "",
            ]);
        }

        ExportsUtil.exportArrAsCsv(
            tableArr,
            `${fileNamePrefix}${projectId}_${Moment(this.state.displayDate).format('YYYY-MM')}`,
            Strings['en'].export.DOWNLOAD_CSV_FILE
        );  
    }

    render() {
        const userIsAdmin = !!this.props.signInStoreState.userInfo.admin;
        let channelShareReport = null;
        let channelActivityShareMonthStats = null;
        let channelProjectShareMonthStats = null;
        // if any table heights has more than 6 rows, set height to static 500px.
        // otherwise, let the table height be dynamic based on content. (undefined tableHeight prop)
        let actTableHeight;
        let projTableHeight;
        let actAccessorTableHeight;
        let projAccessorTableHeight;
        if (this.state.displayDate) {
            channelShareReport = this.getChannelShareReport(AnalyticsStore.getState(), this.props.channelId, this.state.displayDate);
            if (!!channelShareReport && channelShareReport.activities.length > 6) {
                actTableHeight = 500;
            }

            if (!!channelShareReport && channelShareReport.projects.length > 6) {
                projTableHeight = 500;
            }

            if (this.state.selectedProjectId) {
                channelProjectShareMonthStats = this.getChannelProjectShareMonthStats(AnalyticsStore.getState(), this.props.channelId, this.state.selectedProjectId, this.state.displayDate);
                if (!!channelProjectShareMonthStats && channelProjectShareMonthStats.accessors.length > 6) {
                    projAccessorTableHeight = 500;
                }
            }

            if (this.state.selectedActivityId) {
                channelActivityShareMonthStats = this.getChannelActivityShareMonthStats(AnalyticsStore.getState(), this.props.channelId, this.state.selectedActivityId, this.state.displayDate);
                if (!!channelActivityShareMonthStats && channelActivityShareMonthStats.accessors.length > 6) {
                    actAccessorTableHeight = 500;
                }
            }
            
        }

        const filteredActivities = [];
        let selectedProjectName = '';
        if (this.state.selectedProjectId) {
            channelShareReport.activities.forEach((act) => {
                if (act.project_id == this.state.selectedProjectId) {
                    filteredActivities.push(act);
                }
            });

            selectedProjectName = get(channelShareReport.projects.find(p => p.project_id == this.state.selectedProjectId), 'name', '');
        }

        return (
            <div className={"channelShareReport " + this.props.className}>
                <Row className="margin-bottom-lg">
                    <div className="col-12 col-md-12 col-lg-5 margin-bottom-md">
                        <div className="md-heading">
                            {Strings['en'].analytics.new_students.share.HEADING} {(!!this.state.displayDate) && <span>({Moment(this.state.displayDate).format('MM/YYYY')})</span>}
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-5 margin-bottom-md">
                        <label className="label-form margin-right-sm">
                            {Strings['en'].common.DATE}
                        </label>
                        <DatePicker
                            className="margin-right-md"
                            selected={this.state.pickerDate}
                            onChange={this.onPickerDateChange}
                            maxDate={new Date()}
                            dateFormat="MM/YYYY"
                            showMonthYearPicker
                            disabled={!!this.state.getChannelShareReportActionId}
                            placeholderText={!!this.state.getChannelShareReportActionId ? Strings['en'].common.LOADING : ''}
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-2 margin-bottom-md">
                        <Button
                            disabled={!!this.state.getChannelShareReportActionId}
                            onClick={this.onUpdate}
                        >
                            {Strings['en'].common.UPDATE}
                        </Button>
                    </div>
                </Row>
                <div>
                    <ErrorBox error={this.state.getChannelShareReportError} />
                    {(!!channelShareReport) &&
                        <div>
                            <Row className={`${this.props.className}`}>
                                <StatTile
                                    className="text-centered border-right col-12 col-lg-3"
                                    term={Strings['en'].analytics.new_students.share.TOTAL_PROJS}
                                    termTooltip={Strings['en'].analytics.new_students.share.TOTAL_PROJS_TT}
                                >
                                    {channelShareReport.totalProjects}
                                </StatTile>
                                <StatTile
                                    className="text-centered border-right col-12 col-lg-3"
                                    term={Strings['en'].analytics.new_students.share.TOTAL_ACTS}
                                    termTooltip={Strings['en'].analytics.new_students.share.TOTAL_ACTS_TT}
                                >
                                    {channelShareReport.totalActivities}
                                </StatTile>
                                <StatTile
                                    className="text-centered border-right col-12 col-lg-3"
                                    term={Strings['en'].analytics.new_students.share.TOTAL_SHARES}
                                    termTooltip={Strings['en'].analytics.new_students.share.TOTAL_SHARES_TT}
                                >
                                    {channelShareReport.sharesNonUniqueTotal}
                                </StatTile>
                                <StatTile
                                    className="text-centered col-12 col-lg-3"
                                    term={Strings['en'].analytics.new_students.share.TOTAL_UNIQUE_SHARES}
                                    termTooltip={Strings['en'].analytics.new_students.share.TOTAL_UNIQUE_SHARES_TT}
                                >
                                    {channelShareReport.sharesTotal}
                                </StatTile>
                            </Row>
                            <div className="margin-top-xl">
                                <div className="margin-bottom-md">
                                    <span className="md-heading">
                                        {Strings['en'].analytics.new_students.share.PROJ_TABLE_HEADING}
                                    </span>
                                    <Button
                                        variant="secondary"
                                        className='btn-sm fr margin-right-md'
                                        disabled={!!this.state.getChannelShareReportActionId || !channelShareReport.projects || !channelShareReport.projects.length}
                                        onClick={this.onExportProjects.bind(this, channelShareReport.projects, Strings['en'].analytics.new_students.share.PROJ_SHARE_CSV_PREFIX)}
                                    >
                                        {Strings['en'].analytics.new_students.share.DOWNLOAD_PROJ_SHARE_CSV}
                                    </Button>
                                    <div className="float-clear" />
                                </div>
                                <SortableTableClassic
                                    tableHeight={projTableHeight}
                                    dateFormat="YYYY-MM-DD HH:MM:ss z"
                                    dateFormatUTC
                                    hideFilter
                                    hideTotal
                                    uniqueRowKey="project_id"
                                    rows={channelShareReport.projects}
                                    selectedRowKey={this.state.selectedProjectId}
                                    onRowClick={(e, projectId) => {
                                        if (!userIsAdmin) return;
                                        this.setState({ selectedProjectId: projectId });
                                    }}
                                    defaultSort={{ key: 'count', type: 'int', asc: false }}
                                    columns={[
                                        {
                                            key: 'name',
                                            displayName: Strings['en'].analytics.new_students.share.proj_table.PROJECT_NAME,
                                            type: 'string',
                                            size: 3,
                                        },
                                        {
                                            key: 'first_access_date',
                                            displayName: Strings['en'].analytics.new_students.share.proj_table.FIRST_ACCESS_DATE,
                                            type: 'date',
                                            size: 2,
                                        },
                                        {
                                            key: 'count',
                                            displayName: Strings['en'].analytics.new_students.share.proj_table.UNIQUE_SHARES,
                                            type: 'int',
                                            size: 1,
                                        },
                                        {
                                            key: 'count_non_unique',
                                            displayName: Strings['en'].analytics.new_students.share.proj_table.TOTAL_SHARES,
                                            type: 'int',
                                            size: 1,
                                        }
                                    ]}
                                    displayColumnCallbacks={{
                                        'share_count': (count) => StringUtil.numberToLocaleString(count),
                                        'student_count': (count) => StringUtil.numberToLocaleString(count),
                                    }}
                                />
                                {(channelShareReport.projects.length === 0) &&
                                    <div className="margin-top-lg font-style-italic text-center">
                                        {Strings['en'].analytics.new_students.share.NO_SHARE_FOR_PERIOD}
                                    </div>
                                }
                            </div>
                            {(userIsAdmin && !!this.state.selectedProjectId) &&
                                <Card className="margin-top-xl">
                                    <Card.Header>
                                        {Strings['en'].analytics.new_students.share.ADMIN_PROJ_HEADING}
                                        <Button
                                            className='btn-sm fr'
                                            disabled={!!this.state.getChannelProjectShareReportActionId}
                                            onClick={this.onUpdateProject}
                                        >
                                            {Strings['en'].analytics.new_students.share.ADMIN_PROJ_BUTTON}
                                        </Button>
                                        {(!!channelProjectShareMonthStats) &&
                                            <Button
                                                variant="secondary"
                                                className='btn-sm fr margin-right-md'
                                                disabled={!!this.state.getChannelProjectShareReportActionId}
                                                onClick={this.onExportAccessors.bind(this, channelProjectShareMonthStats.accessors, Strings['en'].analytics.new_students.share.PROJ_ACCESSOR_CSV_PREFIX)}
                                            >
                                                {Strings['en'].analytics.new_students.share.DOWNLOAD_ACCESSOR_CSV}
                                            </Button>
                                        }
                                        <div className="float-clear" />
                                    </Card.Header>
                                    <Card.Body>
                                        <ErrorBox error={this.state.getChannelProjectShareReportError} />
                                        {(!!channelProjectShareMonthStats) ?
                                            <SortableTableClassic
                                                tableHeight={projAccessorTableHeight}
                                                dateFormat="YYYY-MM-DD HH:MM:ss z"
                                                dateFormatUTC
                                                hideFilter
                                                hideTotal
                                                uniqueRowKey="ip_address"
                                                rows={channelProjectShareMonthStats.accessors}
                                                defaultSort={{ key: 'total_shares', type: 'int', asc: false }}
                                                columns={[
                                                    {
                                                        key: 'ip_address',
                                                        displayName: Strings['en'].analytics.new_students.share.accessor_table.IP_ADDRESS,
                                                        type: 'string',
                                                        size: 3,
                                                    },
                                                    {
                                                        key: 'first_access_date',
                                                        displayName: Strings['en'].analytics.new_students.share.accessor_table.FIRST_ACCESS_DATE,
                                                        type: 'date',
                                                        size: 2,
                                                    },
                                                    {
                                                        key: 'total_shares',
                                                        displayName: Strings['en'].analytics.new_students.share.accessor_table.TOTAL_ACCESSES,
                                                        type: 'int',
                                                        size: 1,
                                                    }
                                                ]}
                                                displayColumnCallbacks={{
                                                    'total_shares': (count) => StringUtil.numberToLocaleString(count)
                                                }}
                                            />
                                            :
                                            <div className="font-style-italic text-center">
                                                {Strings['en'].analytics.new_students.share.ADMIN_ACCESS_UNLOADED}
                                            </div>
                                        }
                                    </Card.Body>
                                </Card>
                            }
                            {(!!this.state.selectedProjectId) &&
                                <div className="margin-top-xl">
                                    <div className="margin-bottom-md">
                                        <span className="md-heading">
                                            {Strings['en'].analytics.new_students.share.ACT_TABLE_HEADING}
                                        </span>
                                        <Button
                                            variant="secondary"
                                            className='btn-sm fr margin-right-md'
                                            disabled={!!this.state.getChannelShareReportActionId || !filteredActivities || !filteredActivities.length}
                                            onClick={this.onExportActivities.bind(this, filteredActivities, this.state.selectedProjectId, selectedProjectName, Strings['en'].analytics.new_students.share.ACTS_SHARE_CSV_PREFIX)}
                                        >
                                            {Strings['en'].analytics.new_students.share.DOWNLOAD_ACT_SHARE_CSV}
                                        </Button>
                                        <div className="float-clear" />
                                    </div>
                                    <SortableTableClassic
                                        tableHeight={actTableHeight}
                                        dateFormat="YYYY-MM-DD HH:MM:ss z"
                                        dateFormatUTC
                                        hideFilter
                                        hideTotal
                                        rows={filteredActivities}
                                        selectedRowKey={this.state.selectedActivityId}
                                        onRowClick={(e, actId) => {
                                            if (!userIsAdmin) return;
                                            this.setState({ selectedActivityId: actId });
                                        }}
                                        defaultSort={{ key: 'count', type: 'int', asc: false }}
                                        columns={[
                                            {
                                                key: 'title',
                                                displayName: Strings['en'].analytics.new_students.share.act_table.ACTIVITY_TITLE,
                                                type: 'string',
                                                size: 3,
                                            },
                                            {
                                                key: 'first_access_date',
                                                displayName: Strings['en'].analytics.new_students.share.act_table.FIRST_ACCESS_DATE,
                                                type: 'date',
                                                size: 2,
                                            },
                                            {
                                                key: 'count',
                                                displayName: Strings['en'].analytics.new_students.share.act_table.UNIQUE_SHARES,
                                                type: 'int',
                                                size: 1,
                                            },
                                            {
                                                key: 'count_non_unique',
                                                displayName: Strings['en'].analytics.new_students.share.act_table.TOTAL_SHARES,
                                                type: 'int',
                                                size: 1,
                                            }
                                        ]}
                                        displayColumnCallbacks={{
                                            'share_count': (count) => StringUtil.numberToLocaleString(count),
                                            'student_count': (count) => StringUtil.numberToLocaleString(count),
                                        }}
                                    />
                                    {(channelShareReport.activities.length === 0) &&
                                        <div className="font-style-italic text-center">
                                            {Strings['en'].analytics.new_students.share.NO_SHARE_FOR_PERIOD}
                                        </div>
                                    }
                                </div>
                            }
                            {(userIsAdmin && !!this.state.selectedActivityId) &&
                                <Card className="margin-top-xl">
                                    <Card.Header>
                                        {Strings['en'].analytics.new_students.share.ADMIN_ACT_HEADING}
                                        <Button
                                            className='btn-sm fr'
                                            disabled={!!this.state.getChannelActivityShareReportActionId}
                                            onClick={this.onUpdateActivity}
                                        >
                                            {Strings['en'].analytics.new_students.share.ADMIN_ACT_BUTTON}
                                        </Button>
                                        {(!!channelActivityShareMonthStats) &&
                                            <Button
                                                variant="secondary"
                                                className='btn-sm fr margin-right-md'
                                                disabled={!!this.state.getChannelProjectShareReportActionId}
                                                onClick={this.onExportAccessors.bind(this, channelActivityShareMonthStats.accessors, Strings['en'].analytics.new_students.share.ACT_ACCESSOR_CSV_PREFIX)}
                                            >
                                                {Strings['en'].analytics.new_students.share.DOWNLOAD_ACCESSOR_CSV}
                                            </Button>
                                        }
                                        <div className="float-clear" />
                                    </Card.Header>
                                    <Card.Body>
                                        <ErrorBox error={this.state.getChannelActivityShareReportError} />
                                        {(!!channelActivityShareMonthStats) ?
                                            <SortableTableClassic
                                                tableHeight={actAccessorTableHeight}
                                                dateFormat="YYYY-MM-DD HH:MM:ss z"
                                                dateFormatUTC
                                                hideFilter
                                                hideTotal
                                                uniqueRowKey="ip_address"
                                                rows={channelActivityShareMonthStats.accessors}
                                                defaultSort={{ key: 'total_shares', type: 'int', asc: false }}
                                                columns={[
                                                    {
                                                        key: 'ip_address',
                                                        displayName: Strings['en'].analytics.new_students.share.accessor_table.IP_ADDRESS,
                                                        type: 'string',
                                                        size: 3,
                                                    },
                                                    {
                                                        key: 'first_access_date',
                                                        displayName: Strings['en'].analytics.new_students.share.accessor_table.FIRST_ACCESS_DATE,
                                                        type: 'date',
                                                        size: 2,
                                                    },
                                                    {
                                                        key: 'total_shares',
                                                        displayName: Strings['en'].analytics.new_students.share.accessor_table.TOTAL_ACCESSES,
                                                        type: 'int',
                                                        size: 1,
                                                    }
                                                ]}
                                                displayColumnCallbacks={{
                                                    'total_shares': (count) => StringUtil.numberToLocaleString(count)
                                                }}
                                            />
                                            :
                                            <div className="font-style-italic text-center">
                                                {Strings['en'].analytics.new_students.share.ADMIN_ACCESS_UNLOADED}
                                            </div>
                                        }
                                    </Card.Body>
                                </Card>
                            }
                        </div>
                    }
                </div>
            </div>
        );
    }
}

ChannelShareReport.propTypes = propTypes;
ChannelShareReport.defaultProps = defaultProps;

export default withSignInStoreState(ChannelShareReport);